<template>
	<div class="main-cont">
		<div class="wrapper-back-ini"/>
		<div class="wrapper-back-end"/>
		<div class="wrapper-cont">
			<!--
			<div class="header-title">
				<h1 class="header-desc">{{ intro }}</h1>
			</div>
			-->
			<div class="topend-cont">
				<ProcCard :idx="1" :img="conts[0].img" :head="conts[0].h" :cont="conts[0].c"/>
			</div>
			<div class="middle-cont">
				<ProcCard :idx="2" :img="conts[1].img" :head="conts[1].h" :cont="conts[1].c"/>
				<ProcCard :idx="2" :img="conts[2].img" :head="conts[2].h" :cont="conts[2].c"/>
			</div>
			<div class="topend-cont">
				<ProcCard :idx="3" :img="conts[3].img" :head="conts[3].h" :cont="conts[3].c"/>
			</div>
		</div>
	</div>
</template>

<script>
import ProcCard from './ProcCard.vue';

export default {
  components: 	{ProcCard},
  data () {
    return {
	  intro: '¿Cómo será el proceso propuesto por electchain.io?',
	  conts:[
		{ h: '¿Que información necesito para registrarme?', c: 'Para generar tu acceso a electchain, necesitarás el código QR de tu INE y un smartphone basado en android, así como la aplicación oficial de Electchain. Con esto, pretendemos que cada identidad se asocie con dos datos únicos.'},
		{ h: '¿Porqué necesitan mi información personal?' , c: 'Electchain, al ser una iniciativa independiente NO cuenta con el apoyo de instituciones públicas ni prívadas a excepción del Instituto Politécnico Nacional. Por ésta razón es necesario que Electchain construya su propio registro de votantes.'},
		{ h: 'Entonces... ¿Qué harán con mi información?' , c: 'Electchain transformará tu código QR contenido en el INE y el identificador de tu smartphone a datos completamente ILEGIBLES por medio de funciones HASH. Esto tiene como fin hacer IMPOSIBLE el reconocimiento de los datos ORIGINALES.'},
		{ h: '¿Cómo se que no manipularán mi información?', c: 'La información guardada en el Blockchain es pública. Sí nosotros compartieramos tu información LEGIBLE en el Blockchain, entonces todo mundo podriá acceder a ella. Esto es completamente ilegal por lo que la iniciativa no tendriá sentido.'},
	  ],
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*MAIN CONTAINER*/
.main-cont{
	height: 100%;
	overflow: hidden;
	position: relative;
}
/*BACK PARTS*/
.wrapper-back-ini{
	position: absolute;
    left: 0;
    width: 100%;
    height: 33%;

	background:  #102032;

	transform: skewY(-2deg);
    transform-origin: top left;
}
.wrapper-back-end{
	position: absolute;
    left: 0;
	bottom: 0;
    width: 100%;
    height: 33%;

	background:#102032;

	transform: skewY(2deg);
    transform-origin: top left;
}
/*FRONT PARTS*/
.wrapper-cont{
	height: 100%;
	position: relative;
	z-index: 1;
}
.header-title{
	position: absolute;
	left: 0;
	width: 100%;
}
.topend-cont{
	display: inline-flex;
	justify-content: center;
	align-items: center;
	height: 33%;
}
.middle-cont{
	display: inline-flex;
	align-items: center;
	padding: unset;
	height: 33%;
}

@media screen and (min-width: 960px) and (max-width: 1536px){
    .wrapper-back-ini{
		height: 25%;
	}
	.wrapper-back-end{
		height: 25%;
	}
	.topend-cont{
		height: 25%;
	}
	.middle-cont{
		display: inline-grid;
		height: 50%;
	}
}

@media screen and (min-width: 480px) and (max-width: 960px){
    .wrapper-back-ini{
		height: 25%;
	}
	.wrapper-back-end{
		height: 25%;
	}
	.topend-cont{
		height: 25%;
	}
	.middle-cont{
		display: inline-grid;
		height: 50%;
	}
}

@media only screen and (max-width: 480px){
	.wrapper-back-ini{
		height: 25%;
	}
	.wrapper-back-end{
		height: 25%;
	}
	.topend-cont{
		height: 25%;
	}
	.middle-cont{
		display: inline-grid;
		height: 50%;
	}
}
</style>




// WEBPACK FOOTER //
// src/components/TheProcess.vue